/* Expand / collapse group of nav items. Special behaviour to capture click event on expand / contract, so as
not to affect withMenuToggle */

import React from 'react'
import classnames from 'classnames'
import { withStateHandlers } from 'recompose'

const NavGroup = ({ title, children, expanded, toggle }) => (
  <div className={classnames({ 'nav-group': true, expanded })}>
    {title && (
      <h4 onClick={toggle}>
        {title}{' '}
        <i className={classnames({ bx: true, 'bx-chevron-up': expanded, 'bx-chevron-down': !expanded })} />
      </h4>
    )}
    {expanded && children}
  </div>
)

const withExpand = withStateHandlers(({ expanded }) => ({ expanded }), {
  toggle: ({ expanded }) => e => {
    if (e) {
      // Block unfavourable interaction with `withMenuToggle`
      e.stopPropagation()
      e.nativeEvent.stopPropagation()
      e.nativeEvent.stopImmediatePropagation()
    }
    console.log(e)
    return { expanded: !expanded }
  }
})

export default withExpand(NavGroup)



// WEBPACK FOOTER //
// ./src/common/ui/components/NavGroup.jsx